// extracted by mini-css-extract-plugin
module.exports = {"Header":"Form_Header__U5n8X","Inputs":"Form_Inputs__3uMMd","InputNumber":"Form_InputNumber__vhgra"};